<div class="container">

	<div class="portalCard">

		<div class="rowScreenColPhone">

			<div class="aTitle">
				<mat-icon>arrow_circle_down</mat-icon>
				<span>Datenpflege</span>
			</div>

			<mat-spinner diameter=30 [ngClass]="{hiddenCircle: !bInProgress}"></mat-spinner>

		</div>

		<h3
			*ngIf="!member.mitgliedId && !bAdmin" 
			style="text-align: center"
		>
			<p *ngIf="bInProgress">Laden läuft...</p>
			<p *ngIf="!bInProgress">Ihrem Konto ist kein Mitglied zugeordnet</p>
		</h3>

		<ng-container *ngIf="member.mitgliedId || bAdmin">

			<div style="margin: 0em auto 0 auto; max-width: 50em;">

				<div style="margin:1em auto; text-align:center">

					@if( !bAdmin ) {
						<span class="customBtn mat-title" (click)="showInfoMember()">
							{{member.mitgliedsname}}
							<span class="material-icons btnShowInfo" style="margin-left: .5em">info_outline</span>
						</span>
					}
					@else {
						<div style="display: flex; flex-flow: row nowrap; gap: 20px">

							<mat-select
								class="selectMember"
								[(value)]="memberIdSelected"
								[disabled]="bInProgress"
								(selectionChange)="refreshMemberSelected()"
							>
								<mat-option *ngFor="let m of members" [value]="m.mitgliedId">
									{{m.mitgliedsname}}
								</mat-option>
							</mat-select>
							<span
								class="customBtn mat-title" style="vertical-align: bottom;"
								(click)="showInfoMember()"
							>
								<span class="material-icons btnShowInfo" style="margin-left: .5em">info_outline</span>
							</span>

						</div>
					}

				</div>

				<div class="flexRow2">

					<mat-form-field appearance="outline">
						<mat-label>Sparte</mat-label>
						<mat-select
							[(value)]="idSectionSelected" 
							(selectionChange)="refreshSectionAndYear()" 
							[disabled]="(sections.length <= 1) || bInProgress"
						>
							<mat-option *ngIf="sections.length > 1" value="ALLE">Alle</mat-option>
							<mat-option *ngFor="let s of sections" [value]="s.sparteId">
								{{s.sparteBezeichnung}}
							</mat-option>
						</mat-select>
					</mat-form-field>

					<mat-form-field appearance="outline">
						<mat-label>Berichtsjahr</mat-label>
						<mat-select
							[(value)]="yearSelected" 
							(selectionChange)="refreshSectionAndYear()" 
							[disabled]="(years.length <= 1) || bInProgress"
						>
							<mat-option *ngFor="let y of years" [value]="y.bjJahr">
								{{y.bjJahr}}
							</mat-option>
						</mat-select>
					</mat-form-field>

				</div>

				<form
					*ngIf="sections.length && years.length"
					[formGroup]="formG1" 
					style="display: flex; flex-flow: column nowrap; margin: 1em 0 2em 0;"
				>

					<div class="flexRow2" style="margin: 1em 0;">
						<div></div>
						<triv-input 
							style="width:100%"
							[fGroup]="formG1" 
							[data]="myInputs.bjmGeschaetzt"></triv-input>
					</div>

					<div class="flexRow2">

						<mat-form-field appearance="outline">
							<mat-label>Anzahl Mitglieder</mat-label>

							<input
								matInput
								type="text" 
								placeholder=""
								(keyup)="inputKeyUpEmployee($event)"
								(blur)="inputBlurredEmployee($event)"
								[formControl]="employeeNumberCtrl"
								style="text-align: right;"
							>

						</mat-form-field>

						<triv-input 
							style="width:100%"
							[fGroup]="formG1" 
							[data]="myInputs.dm_editable_until"></triv-input>

					</div>

					<!--
						<triv-input 
							style="width:100%"
							[fGroup]="formG1" 
							[data]="myInputs.dm_number_of_customers"></triv-input>

					-->


					<div class="flexRow2">

						<mat-form-field appearance="outline">
							<mat-label>Eigenkapital</mat-label>

							<input
								matInput
								type="text" 
								placeholder=""
								(keyup)="inputKeyUpCurrency($event)"
								(blur)="inputBlurredCurrency($event)"
								[formControl]="capitalCtrl"
								style="text-align: right;"
							>

						</mat-form-field>

						<mat-form-field appearance="outline">
							<mat-label>satzungsmäßige Verlustrücklage</mat-label>

							<input
								matInput
								type="text" 
								placeholder=""
								(keyup)="inputKeyUpCurrency($event)"
								(blur)="inputBlurredCurrency($event)"
								[formControl]="lossReserveCtrl"
								style="text-align: right;"
							>

						</mat-form-field>

						<!--
							<triv-input 
								style="width:100%"
								[fGroup]="formG1" 
								[data]="myInputs.dm_capital"></triv-input>
							<span style="width: 4em;"></span>
							<triv-input 
								style="width:100%"
								[fGroup]="formG1" 
								[data]="myInputs.dm_loss_reserve"></triv-input>
						-->	
					</div>
					
				</form>

			</div>

			<!-- VERTICAL
			<div style="display: flex; flex-flow: row wrap; justify-content: space-evenly; margin: 1em auto" >
				<div *ngFor="let sectionId of selectedSectionsId"
					style="max-width: 30em; margin: .5em 2em 3em 2em">

					<div class="atable">
				
						<div class="arow arowheader">
							<div>{{sectionName(sectionId)}}</div>
						</div>
						<div class="arow" style="align-items: center;" *ngFor="let t of TWIGS">

								normalized fields
									style="padding: 0px 1em !important"
								<mat-form-field appearance="standard"  style="min-width: 18em;">
									<mat-label>{{t.label}}</mat-label>
									<input matInput type="number" placeholder="" [(ngModel)]="dataFormular[sectionId][t.id]">
								</mat-form-field>

							<div style="text-align: right; padding-right: 1em;">{{t.label}}</div>
							<input type="number" placeholder="" class="aninput" [(ngModel)]="dataFormular[sectionId][t.id]">


						</div>
					
					</div>
				</div>
			</div>  -->

			<!-- HORIZONTAL -->
			<div *ngIf="!sections.length" style="text-align: center; font-size: larger">

				<ng-container *ngIf="!bAdmin">
					Keine Sparten werden Ihrem Konto zugeordnet. 
					Bitte wenden Sie sich an Ihren Administrator
				</ng-container>

				<ng-container *ngIf="bAdmin">
					Keine Sparte sind dieses Mitglied zugewiesen
				</ng-container>

			</div>

			<div *ngIf="!years.length" style="text-align: center; font-size: larger">

				<ng-container *ngIf="!bAdmin">
					Es sind keine Jahre verfügbar. Bitte wenden Sie sich an Ihren Administrator
				</ng-container>

				<ng-container *ngIf="bAdmin">
					Es sind keine Jahre verfügbar
				</ng-container>

			</div>

			<!-- <ng-container *ngIf="selectedSectionsId.length">			 -->
			<ng-container 
				*ngIf="selectedSectionsId.length && years.length && !bInitializingInProgress"
			>

				<div id="horizontal-scroll-except-first-column">
					<table>
						<tr>
							<th></th>
							<th *ngFor="let t of TWIGS" class="thTwigHeader">
								<label [label]="t.label" [info]="t.info"></label>
							</th>
						</tr>
						<tr *ngFor="let sectionId of selectedSectionsId">
							<td>
								{{sectionName(sectionId)}}
							</td>
							<td *ngFor="let t of TWIGS">
								<input 
									type="text" 
									placeholder=""
									[disabled]="yearFrozen || !bMaintenanceRights"
									(keyup)="inputKeyUp($event, sectionId, t)"
									(blur)="inputBlurred($event, sectionId, t)"
									[ngModel]="dataFormularOriginal[sectionId][t.id]"
								>
								<!-- id="{{'input__'+sectionId+'__'+t.id}}" -->
								<!-- [value]="dataFormularOriginal[sectionId][t.id]" -->
							</td>
							<!-- (change)="inputChanged($event, sectionId, t)" -->
						</tr>
						<tr *ngIf="selectedSectionsId.length > 0"
							style="text-align: right;">
							<td>Total Summe</td>
							<td *ngFor="let t of TWIGS"
								class="tdSum">
								{{totaux[t.id]}}
							</td>
						</tr>
					</table>
				</div>

				<div class="divPublishButtons">

					<button
						mat-raised-button
						(click)="print()"
					>
						<span class="material-icons">print</span>
						Drucken
					</button>

					<button mat-raised-button color="accent"
						(click)="publish()" 
						[disabled]="!bMaintenanceRights || !formG1.valid || ryml.bjmFreigabe">
						<span class="material-icons">lock</span>
						Freigeben
					</button>

					<button mat-raised-button color="warn"
						*ngIf="bAdmin"
						(click)="unpublish()" 
						[disabled]="!ryml.bjmFreigabe">
						<span class="material-icons">lock_open</span>
						Freigabe zurücknehmen
					</button>

				</div>

			</ng-container>
	

		</ng-container>

	</div>

</div>
